<template>
  <p>{{ __('thanks_for_the_order_description') }}</p>
  <p>
    {{
      __('order_total_price_description', {
        price: `${Helper.formatPrice(getTotalPriceWithVat)} ${currency}`
      })
    }}
  </p>
</template>

<script>
import useBasket from '@/stores/Basket';
import Helper from '@/libraries/Helpers';
import { computed } from 'vue';

export default {
  name: 'SuccessInvoicePayment',
  setup() {
    const { getTotalPriceWithVat, getSettings } = useBasket();
    return {
      currency: computed(() => getSettings('currency')),
      getTotalPriceWithVat: computed(() => getTotalPriceWithVat()),
      Helper
    };
  }
};
</script>
